import { render, staticRenderFns } from "./ZodiacManagementScreen.vue?vue&type=template&id=16a71688&scoped=true&"
import script from "./ZodiacManagementScreen.vue?vue&type=script&lang=js&"
export * from "./ZodiacManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a71688",
  null
  
)

export default component.exports